export default __webpack_public_path__ + "static/media/drink coffee2.cd4b30d1.png";